var _defs, _path, _path2, _circle, _circle2, _path3, _path4, _circle3, _rect, _path5, _path6, _path7, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 59.043,
    y1: 64.688,
    x2: 79.685,
    y2: 64.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 51.331,
    y1: 96.923,
    x2: 62.11,
    y2: 96.923,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 63.397,
    y1: 108.989,
    x2: 74.176,
    y2: 108.989,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 64.408,
    y1: 147.03,
    x2: 74.54,
    y2: 147.03,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 66.847,
    y1: 85.115,
    x2: 80.174,
    y2: 85.115,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 55.538,
    y1: 43.677,
    x2: 83.641,
    y2: 43.677,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 32.563,
    y1: 140.563,
    x2: 106.653,
    y2: 140.563,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 123.072,
    y1: 114.305,
    x2: 158.288,
    y2: 114.305,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c",
    x1: 126.211,
    y1: 70.468,
    x2: 154.314,
    y2: 70.468,
    xlinkHref: "#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M60.293 63.906c9.827 6.047 11.631-2.275 18.142-.39",
    stroke: "url(#SVGID_0_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.293 47.282h18.141v23.776c0 .304.198.568.488.66 13.039 4.131 22.33 16.687 21.483 31.276-.892 15.362-13.275 27.892-28.626 28.951-18.039 1.244-33.059-13.021-33.059-30.794 0-13.632 8.837-25.336 21.095-29.428a.693.693 0 00.478-.657V47.282z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 56.72,
    cy: 96.923,
    r: 4.139,
    stroke: "url(#SVGID_1_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 68.786,
    cy: 108.989,
    r: 4.139,
    stroke: "url(#SVGID_2_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M63.448 152.812h12.051a3.157 3.157 0 013.155 3.155v.803a.545.545 0 01-.545.545h-17.27a.545.545 0 01-.545-.545v-.803a3.157 3.157 0 013.155-3.155z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M73.29 148.785c0 3.192-1.708 4.023-3.816 4.023s-3.816-.832-3.816-4.023 3.816-7.534 3.816-7.534 3.816 4.343 3.816 7.534z",
    stroke: "url(#SVGID_3_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 73.511,
    cy: 85.115,
    r: 5.413,
    stroke: "url(#SVGID_4_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 56.788,
    y: 40.16,
    width: 25.603,
    height: 7.035,
    rx: 3.518,
    ry: 3.518,
    stroke: "url(#SVGID_5_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_6_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)",
    d: "M33.813 157.315l7.608-34.454h-4.487 64.47-3.901l7.9 35.405"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M124.322 114.316s9.797-4.684 16.358-2.353c9.364 3.326 12.944 5.572 16.358 5.315",
    stroke: "url(#SVGID_7_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M130.984 97.665l-15.064 37.653c-1.152 2.881.969 6.014 4.071 6.014h40.232c3.101 0 5.222-3.13 4.073-6.01L149.27 97.664a2.878 2.878 0 01-.205-1.069V74.034h-17.874v22.56c0 .367-.07.731-.206 1.072zM136.104 80.69h3.56M136.104 88.261h3.56M136.104 95.832h3.56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "MI_4L_gradient",
    x: 127.461,
    y: 66.904,
    width: 25.603,
    height: 7.129,
    rx: 3.565,
    ry: 3.565,
    stroke: "url(#SVGID_8_a425d94ee55e6f376d0df63302e48ba0c3edf619e1a63ffa2e61b2caacd5450c)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemo);
export default __webpack_public_path__ + "static/media/demo.0a38643cabf02851a031026ff990d256.svg";
export { ForwardRef as ReactComponent };